import { IHappyHourAdminConfig } from "../../models/IHappyHour";
import ApiService from "../api/api.service";

const getAdminConfig = async () => {
    return ApiService.getJson<IHappyHourAdminConfig>("/admin/happy-hour");
}

const updateAdminConfig = async (payload: Partial<IHappyHourAdminConfig>) => {
    return ApiService.putJson<IHappyHourAdminConfig>("/admin/happy-hour", payload);
}

const HappyHourService = {
    getAdminConfig,
    updateAdminConfig
}

export default HappyHourService
